import { MessageCircle } from "lucide-react";
import { useSite } from "../lib/SiteContext";
import { waLink } from "../lib/api";

const WhatsAppFloat = () => {
  const { content } = useSite();
  return (
    <a
      href={waLink(content?.settings)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Aloha Corfu Tours on WhatsApp"
      data-testid="floating-whatsapp-button"
      className="animate-wa-pulse fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lift transition-transform duration-300 hover:scale-110"
    >
      <MessageCircle className="h-7 w-7" />
    </a>
  );
};

export default WhatsAppFloat;
